import React from "react";
import Picker from 'react-month-picker'
import MonthBox from '../month-box'

class MonthPicker extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            pcikerShown: false
        }

        this._handleClickRangeBox = this._handleClickRangeBox.bind(this)
        this.handleRangeChange = this.handleRangeChange.bind(this)
        this.handleRangeDissmis = this.handleRangeDissmis.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps){
        this.setState({
            value: nextProps.value || 'N/A',
        })
    }

    componentDidUpdate() {
        if (!this.state.pcikerShown) {
            this.refs.pickRange.show()
        }

    }

    _handleClickRangeBox(e) {
        this.refs.pickRange.show()
    }

    handleRangeChange(year, month, listIndex) {
        if (listIndex === 0) {
            this.props.updateFrom({year: year, month: month})
        } 
        if (listIndex === 1) {
            this.props.updateTo({year: year, month: month})
        }
    }
    handleRangeDissmis(value) {

        this.props.updateRange(value)
        this.setState({pcikerShown: false})
    }

    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'Maí', 'Jún', 'Júl', 'Ágú', 'Sep', 'Okt', 'Nóv', 'Des'],
            from: 'Frá', to: 'Til',
        }
        const mrange = this.props.mrange

        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year)
            return '?'
        }

        return (
            <div>
                <div className="overview-modal-header">
                    <label>Veljið tímabil</label>
                    <div className="monthbox">
                        <MonthBox value={makeText(mrange.from) + ' - ' + makeText(mrange.to)} onClick={this._handleClickRangeBox} />
                    </div>
                </div>
                <div className="picker">
                    <Picker
                        ref="pickRange"
                        years={{min: 2000}}
                        value={mrange}
                        lang={pickerLang}
                        theme="light"
                        onChange={this.handleRangeChange}
                        onDismiss={this.handleRangeDissmis}
                        onShow={() => {this.setState({pcikerShown: true})}}
                    >
                    </Picker>
                </div>
            </div>
        )
    }
}


export default MonthPicker;